import { TdsNavigation as Navigation, TdsNavigationProps } from '@tencent/tds-ui-lite';
import React, { FC } from 'react';

export const TdsNavigation: FC<TdsNavigationProps> = props => (
  <Navigation {...props} />
);

export { TdsItem } from '@tencent/tds-ui-lite';
